import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Card, Row, Col, Nav } from 'react-bootstrap'
import '../../../../node_modules/react-vis/dist/style.css';
//import '../node_modules/react-vis/dist/style.css';
import {XYPlot, LineMarkSeries, VerticalGridLines, HorizontalGridLines, XAxis, YAxis} from 'react-vis';

class LineChart extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
  
        };
      } 
  
      static defaultProps = {
      }
  
      componentDidMount(){
      }
  
      onItemSelectionChanged = (rowId) => {
  
      }

      render(){
  
        const data = [
            {x: '1 Jan', y: 8},
            {x: '2 Jan', y: 5},
            {x: '3 Jan', y: 4},
            {x: '4 Jan', y: 9},
            {x: '5 Jan', y: 1},
            {x: '6 Jan', y: 7},
            {x: '7 Jan', y: 6},
            {x: '8 Jan', y: 3},
            {x: '9 Jan', y: 2},
            {x: '10 Jan', y: 0}
          ];

          return (
<Nav.Link>
            <Card className = 'p-0'
            bg={this.props.colour}>
                              <Card.Title className='p-4 text-center'>Average Approval Times (Hours)</Card.Title>
            <Card.Body className = 'p-2'>
              <Row>
                <XYPlot height={300} width={480} xType="ordinal">
                    <LineMarkSeries data={data} 
                      lineStyle={{stroke:"#82c9f4"}}
                      markStyle={{fill:"#3977aa", stroke:"#82c9f4" }}
                    />
                    <HorizontalGridLines />
                    <XAxis position="middle"/>
                    <YAxis />
                </XYPlot>
              </Row>
            </Card.Body>
          </Card>
          </Nav.Link>
            );
      }
  
  }
  
  const mapStateToProps = (state) => {
      return{
          fetchingData: state.fetchingData === true
      };
  }
  
  export default connect(
      // map state to props
      mapStateToProps, 
      // map dispatch to props
      (dispatch, ownProps) => ({
  
        })
      )(LineChart);